import { useState } from 'react';
import { ActivityEnhancementOptionsPayload, AiActivityEnhancementSystem, EnhancedActivity } from '../../system/ai/AiActivityEnhancementSystem';
import { MessageEnhancement, TypeMessageEnhancement } from './useProjectEnhancement';
import { AiGradientIconFilled } from '../../Components/AiGradientIcon';
import { t } from 'i18next';

export function useActivityEnhancement(aiActivityEnhancementSystem: AiActivityEnhancementSystem) {
  const [originalData, setOriginalData] = useState<EnhancedActivity>({ activity_description: '', activity_name: '' });
  const [loading, setLoading] = useState(false);
  const [wasGenerated, setWasGenerated] = useState(false);
  const [message, setMessage] = useState<MessageEnhancement>(null);

  const generateEnhancement = async (payload: ActivityEnhancementOptionsPayload, onSuccess: (result: EnhancedActivity) => void) => {
    setLoading(true);
    setOriginalData({
      activity_name: payload.activity_name,
      activity_description: payload.activity_description,
    });
    setMessage(null);
    try {
      const response = await aiActivityEnhancementSystem.enhanceActivity(payload);
      onSuccess(response);
      setWasGenerated(true);
      setMessage({
        type: TypeMessageEnhancement.SUCCESS,
        className: 'success-message-animate',
        value: (
          <div className="message-flex">
            <AiGradientIconFilled /> {t('Redacción de la actividad mejorada con éxito')}
          </div>
        ),
      });
    } catch (err) {
      console.log(err);
      setMessage({ type: TypeMessageEnhancement.ERROR, className: 'error-message-animate', value: t('❌ Ocurrió un problema al mejorar el contenido. Inténtalo nuevamente.') });
    } finally {
      setLoading(false);
    }
  };

  const resetToOriginal = () => {
    setWasGenerated(false);
    setMessage({ type: TypeMessageEnhancement.RESET, className: 'reset-message-animate', value: t('🔄 Los datos han sido restablecidos a su estado original.') });
    return originalData;
  };

  const clearMessage = () => {
    setMessage(null);
  };

  const showMessage = (payload: MessageEnhancement) => {
    setMessage(null);
    setTimeout(() => {
      setMessage(payload);
    }, 0);
  };

  return {
    loading,
    wasGenerated,
    message,
    generateEnhancement,
    resetToOriginal,
    showMessage,
    clearMessage,
  };
}
